import { Count, useRecordContext } from 'react-admin';
import MappingRuleResource from '../../Entities/MappingRules';

// NOTE: label accepted to allow column header customization in Datagrid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function OfferCountField({ label }: { label?: string }) {
  const record = useRecordContext<MappingRuleResource>();

  return (
    <Count
      resource="offers"
      filter={{
        external_category: record?.attributes.external_category,
        merchant: { id: record?.relationships.merchant.data?.id },
      }}
    />
  );
}
